document.addEventListener('DOMContentLoaded', () => {
  const generateSvgButton = document.querySelector('#generate-pdf-link');
  const addToCartButton = document.querySelector('button[data-js-product-add-to-cart]');
  const overlay = document.createElement('div');

  overlay.id = 'interaction-blocker';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.1)';
  overlay.style.zIndex = '99999';
  overlay.style.display = 'none';
  document.body.appendChild(overlay);

  if (generateSvgButton) {
    generateSvgButton.addEventListener('click', async (event) => {
      console.log("Generate SVG button clicked");
      event.preventDefault();
      event.stopPropagation();

      const spinner = document.createElement('span');
      spinner.className = 'spinner';
      generateSvgButton.appendChild(spinner);
      generateSvgButton.disabled = true;
      overlay.style.display = 'block';

      try {
        // SKU auslesen
        const skuElement = document.getElementById('sku');
        const sku = skuElement ? skuElement.textContent.trim() : 'unknown';

        // Farbe aus dynamic-select-color holen
        let selectedColor = 'unknown';       // Hex-Wert
        let selectedColorLabel = 'unknown';  // Anzeigename (z.B. "Gold")

        const colorInput = document.querySelector('.dynamic-select-color .wunschtext-line-color-input');
        if (colorInput) {
          selectedColor = colorInput.value || 'unknown';
        }

        const colorHeaderText = document.querySelector('.dynamic-select-color .dynamic-select-header .dynamic-select-option-text');
        if (colorHeaderText) {
          selectedColorLabel = colorHeaderText.textContent.trim() || selectedColor;
        } else {
          selectedColorLabel = selectedColor;
        }

        // SVG holen
        const svgElement = document.getElementById('svg-print');
        if (!svgElement) throw new Error("SVG element not found");

        // SVG klonen – aber KEINE Größen setzen
        const svgClone = svgElement.cloneNode(true);

        // SVG serialisieren
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(svgClone);
        const blob = new Blob([svgString], { type: "image/svg+xml" });

        // Dateiname: SKU + Farbname (oder Hex) + Random-ID
        const safeColorLabel = selectedColorLabel.replace(/\s+/g, '-'); // Leerzeichen → Bindestriche
        const fileName = `${sku}_${safeColorLabel}_${generateRandomId(8)}.svg`;

        // Upload – an den Server schicken wir den Hex-Wert
        const pdfUrl = await sendToServer(blob, fileName, sku, selectedColor);
        if (pdfUrl) setSvgInputValue(pdfUrl);

      } catch (error) {
        console.error('Error generating SVG:', error);
        alert('There was an error generating the SVG. Please try again.');
      } finally {
        spinner.remove();
        generateSvgButton.disabled = false;
        overlay.style.display = 'none';
        if (addToCartButton) addToCartButton.click();
      }
    });
  } else {
    console.error('Generate SVG button not found.');
  }

  function generateRandomId(length = 8) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
  }

  async function sendToServer(svgBlob, fileName, sku, color) {
    const formData = new FormData();
    formData.append('svgFile', svgBlob, fileName);
    formData.append('sku', sku);
    formData.append('color', color); // Hex-Wert aus dynamic-select-color

    try {
      const response = await fetch('https://design.my-foil.ch/mw-cloud-convert-svg-pdf-2.php', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Server Response:', data);
        return data.pdf_link ?? null;
      } else {
        console.error('Server response not OK:', response.status, response.statusText);
        alert('Server error: ' + response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
      alert('There was a network error while uploading the SVG. Please try again.');
    }

    return null;
  }

  function setSvgInputValue(pdfUrl) {
    const svgInput = document.getElementById('pdf_link');
    if (svgInput) {
      svgInput.value = pdfUrl;
    } else {
      console.error('PDF input field not found');
    }
  }
});
